import { render, staticRenderFns } from "./uploadAndAnalyze.vue?vue&type=template&id=fc7dbb74&scoped=true"
import script from "./uploadAndAnalyze.vue?vue&type=script&lang=js"
export * from "./uploadAndAnalyze.vue?vue&type=script&lang=js"
import style0 from "./uploadAndAnalyze.vue?vue&type=style&index=0&id=fc7dbb74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7dbb74",
  null
  
)

export default component.exports